import {
  createOntologyHeaders,
  type ClearHistorianResult,
  type ClearNeo4jResult,
  type ClearPostgresResult
} from '../core'
import { getOntologyServiceBaseUrl } from '../../config'

export const DEFAULT_FACTORYSIM_LOAD_URL = 'http://127.0.0.1:8085'

export interface LoadFactorySimTagCounts {
  attempted: number
  registered: number
  alreadyExisted: number
  failed: number
}

export type LoadFactorySimOpcResult =
  | { skipped: true; reason: string }
  | {
      skipped: false
      endpoint: string
      tags: LoadFactorySimTagCounts
      overlayNodes: number
      overlayRelationships: number
    }

export interface LoadFactorySimResult {
  factorysimUrl: string
  reachableUrl: string
  persistedGatewayUrl: string
  lineId: string
  sessionState: string
  nodesMerged: number
  relationshipsMerged: number
  historianTags: LoadFactorySimTagCounts
  opc: LoadFactorySimOpcResult
  cleared: {
    neo4j: ClearNeo4jResult
    postgres: Pick<ClearPostgresResult, 'tablesTruncated'>
    historian: Pick<ClearHistorianResult, 'skipped' | 'rowsDeleted'>
  }
}

export interface LoadFactorySimArgs {
  factorysimUrl: string
  project?: string
}

export async function loadFactorySimSession(
  args: LoadFactorySimArgs
): Promise<LoadFactorySimResult> {
  const resp = await fetch(`${getOntologyServiceBaseUrl()}/debug/factorysim:load`, {
    method: 'POST',
    headers: createOntologyHeaders(),
    body: JSON.stringify({
      factorysimUrl: args.factorysimUrl,
      ...(args.project ? { project: args.project } : {})
    })
  })
  const json = (await resp.json().catch(() => ({}))) as {
    result?: LoadFactorySimResult
    error?: string
  }
  if (!resp.ok) {
    throw new Error(json.error || `FactorySim load failed: ${resp.status} ${resp.statusText}`)
  }
  if (!json.result) {
    throw new Error('FactorySim load returned no result')
  }
  return json.result
}
